import React from 'react'
import { Modal } from './Modal'
import { Col, Container, Modal as BootstrapModal, Row } from 'react-bootstrap'
import { Button } from '../Button/Button'

export interface YesNoCancelModalProps {
  show: boolean
  onHide: () => void
  message: string
  onYes: () => void
  onNo: () => void
  title?: string
  showCancel?: boolean
}

export const YesNoCancelModal: React.FC<YesNoCancelModalProps> = ({ show, onHide, message, onYes, onNo, title, showCancel = true }) => {
  return (
    <Modal
      body={
        <Container>
          <Row>
            <Col>{message}</Col>
          </Row>
        </Container>
      }
      header={title ? <BootstrapModal.Title>{title}</BootstrapModal.Title> : <></>}
      footer={
        <Container>
          <div className={`d-flex ${showCancel ? 'justify-content-between' : 'justify-content-end'}`}>
            {showCancel ? (
              <Button variant='secondary' onClick={onHide}>
                Cancel
              </Button>
            ) : null}
            <Row className='d-flex gap-3'>
              <Button variant='secondary' onClick={onNo}>
                No
              </Button>
              <Button variant='primary' onClick={onYes}>
                Yes
              </Button>
            </Row>
          </div>
        </Container>
      }
      centered={true}
      show={show}
      onHide={onHide}
    />
  )
}
